import React from "react";
import { Route } from "react-router-dom";
import { useAuth } from "../auth";
import Spinner from "./spinner";

interface IProps {
  path: string;
  exact: boolean;
  Component: Function;
}

const PrivateRoute = ({ Component, path, ...rest }: IProps) => {
  const { loading, isAuthenticated } = useAuth();

  const render = (props: any) => {
    if (loading || !isAuthenticated) {
      return <Spinner />;
    }

    return <Component {...props} />;
  };

  return <Route path={path} render={render} {...rest} />;
};

export default PrivateRoute;
